import React from 'react';
import { IconProps } from '.';

const SvgTriangleWarning = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M12.75 18.8h-1.5v-2h1.5v2ZM12.75 15.2h-1.5v-6h1.5v6Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M23.898 21.75H.098l11.9-20.23 11.9 20.23Zm-21.176-1.5h18.553L11.998 4.479 2.722 20.25Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTriangleWarning;
